import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  title: {
    fontWeight: '600',
  },
  subTitle: {
    fontWeight: '500',
  },
  text: {
    marginTop: '16px',
    marginBottom: '0px',
    color: theme.colors.grey[650],
    fontSize: '14px',
    maxWidth: '90%',
  },
  link: {
    color: theme.colors.primaryBlue[500],
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  attendanceBadge: {
    display: 'inline-flex',
    width: 'fit-content',
    alignItems: 'center',
    backgroundColor: theme.colors.chip,
    fontSize: '16px',
    borderRadius: '6px',
    padding: '4px 18px',
    marginTop: '16px',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold',
    },
    '& span + span': {
      marginLeft: '20px',
    },
    '& svg': {
      width: '18px',
      height: '18px',
      color: 'inherit',
      marginRight: '2px',
    },
    '& + p': {
      marginTop: '4px',
    }, 
  },
  attendancePresent: {
    color: '#55CEAD',  
  },
  attendanceAbsent: {
    color: '#8690B3',  
  },
  attendanceExcusedAbsent: {
    color: '#9B8AFF',  
  },
  attendanceAbsentPart: {
    color: '#BFC1DC',  
  },
  attendanceStatus: {
    fontWeight: 'bold',  
  },
  attendanceAbsentPartAM: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    width: '9px',
    marginLeft: '-9px',
  },
  attendanceAbsentPartAMPlaceholder: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    width: '9px',
    '& > svg': {
      color: '#FFFFFF !important',
      marginLeft: '-9px',
    },
  },
  attendanceAbsentPartPM: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    width: '9px',
    '& > svg': {
      marginLeft: '-9px',
    },
  },
  attendanceAbsentPartPMPlaceholder: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    width: '9px',
    '& > svg': {
      color: '#FFFFFF !important',
    },
  },
  attendanceRule: {
    color: '#DCDEF8',
    marginLeft: '9.5px',
    marginRight: '9.5px',
    marginBottom: '0px',
  },
  counts: {
    fontSize: '16px',
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold',
      marginTop: '8px',
    },
    '& > p': {
      marginTop: '0',
    },
    '& svg': {
      width: '18px',
      height: '18px',
      color: 'inherit',
      marginRight: '2px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    }, 
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '&:not(:first-of-type)': {
      marginTop: '32px',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: '0 0 100%',
      alignItems: 'center',
    },
  },
  fixLeft: {
    marginLeft: '9px',
  },
  childInfoItem: {
    cursor: 'auto',
    marginTop: '16px',
    display: 'flex',
    '& *': {
      cursor: 'auto',
    },
    '& > div': {
      marginTop: '0px',
      marginRight: '0px',
    },
  },
  childDefaultInfoItem: {
    cursor: 'auto',
    display: 'flex',
    '& *': {
      cursor: 'auto',
    },
    '& > div': {
      marginTop: '0px',
      marginRight: '0px',
    },
  },
  attendanceInfoItem: {
    '& > div': {
      marginBottom: '16px',
      marginLeft: '16px',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '0px',
      }, 
    },
  },
  badges: {
    display: 'flex',
    marginTop: '16px',
    gap: '16px',
  },
}));

export default useStyles;